import { useEffect, useState, useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useDispatch } from "react-redux";
import { CircleStop, User, Mail, AlignLeft, IdCard, Store, ListCheck, Phone, ExternalLink, MapPinIcon, CalendarDays, Image, LockIcon, Binary, Plus, X, Clock } from "lucide-react";

import useDocumentTitle from '../../hooks/useDocumentTitle';
import { fetchcountries, fetchstates, fetchcities, fetchstorecategories, removeStoreImage, fetchstores } from "../../services/api";
import { saveStore } from "../../store/storeSlices/storeSlice";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import { useLocation } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

import Flatpickr from "react-flatpickr";
import "flatpickr/dist/themes/light.css";

import { DateInput } from "@mantine/dates";
// import LocationSelector from "./LocationSelector";
import LocationPickerModal from "./LocationPickerModal";

const DAYS = [
  { key: 'mon', label: 'Monday' },
  { key: 'tue', label: 'Tuesday' },
  { key: 'wed', label: 'Wednesday' },
  { key: 'thu', label: 'Thursday' },
  { key: 'fri', label: 'Friday' },
  { key: 'sat', label: 'Saturday' },
  { key: 'sun', label: 'Sunday' },
];

const defaultStoreTimings = () =>
  DAYS.reduce((acc, { key }) => {
    acc[key] = { is_open: true, open_time: '09:00', close_time: '18:00' };
    return acc;
  }, {});

export default function AddStore({ mode = 'admin' }) {
  const isStore = mode === 'store'; // store editing its own profile (no admin auth/user)
  const { user } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isLocationModalOpen, setIsLocationModalOpen] = useState(false);
  const handleLocationSelect = (location) => {
    setSelectedLocation(location);
    setIsLocationModalOpen(false);
  };
  const generateCardNumber = () => {
    // Get current date/time components
    const now = new Date();
    const hours = now.getHours().toString().padStart(2, '0');
    const minutes = now.getMinutes().toString().padStart(2, '0');
    const seconds = now.getSeconds().toString().padStart(2, '0');
    const day = now.getDate().toString().padStart(2, '0');
    const month = (now.getMonth() + 1).toString().padStart(2, '0');

    // Combine date/time components (this will be 12 digits)
    const timeDigits = `${month}${day}${hours}${minutes}${seconds}`;

    // Generate random digits to fill remaining space (if needed)
    const randomDigits = Math.floor(Math.random() * 10000).toString().padStart(4, '0');
    const cardNumber = `${user?.id ?? ''}${randomDigits}${timeDigits}`.substring(0, 16);
    // Format with spaces for better readability
    const formattedNumber = cardNumber.replace(/(\d{0})/g, '$1').trim();

    return formattedNumber;
  };
  const location = useLocation();
  useDocumentTitle('Welcome to Admin | Add New Store');
  const [CountryList, setCountryList] = useState([])
  const [CategoryList, setCategoryList] = useState([])
  const [StateList, setStateList] = useState([]);
  const [CityList, setCityList] = useState([]);
  const fileInputRef = useRef(null);
  // const [selectedCountry, setselectedCountry] = useState([]);
  const [formData, setFormData] = useState({
    store_name: "",
    store_id: generateCardNumber(),
    address: "",
    settlement_day: "",
    email: "",
    country_code: "91",
    phone: "",
    pincode: "",
    noOfPass: "",
    OTPAllowed: '1',
    FaceRecognition: '0',
    vendortype: '0',
    vendor_category: '',
    swipelimit: '0',
    monthlyswipe: '0',
    swipeinyear: '0',
    country: 0,
    latitude: 0,
    longitude: 0,
    placeId: 0,
    rewardrequired: 0,
    gatenumber: 0,
    gatenumber: 0,
    event_time: '',
    entry_time: '',
    event_date: new Date(),
    // (a) weekly open/close schedule — unchecking a day marks it closed
    store_timings: defaultStoreTimings(),
    // (b) product types the store deals in (e.g. Puma -> Shoes, Sandals)
    product_types: [],
    // (c) enquiry / payment / both — at least one must stay enabled
    enquiry_enabled: '1',
    payment_enabled: '0',
    platform_fee: '',
    platform_fee_payer: 'store',
    // (d) up to 5 gallery images
    store_images: [],
    is_halal: '0',
    food_type: '',
    alcohol_allowed: '0',
  });
  const [productTypeInput, setProductTypeInput] = useState('');
  const [existingGalleryImages, setExistingGalleryImages] = useState([]);

  // useEffect(() => {

  //   if (selectedLocation) {
  //     const countryValue = selectedLocation?.country || '';
  //     const stateValue = selectedLocation?.state || '';
  //     const cityValue = selectedLocation?.city || '';
  //     const match = CountryList?.find(item => item.id == countryValue || item.name.toLowerCase() === String(countryValue).toLowerCase());
  //     const matchState = StateList?.find(item => item.id == stateValue || item.name.toLowerCase() === String(stateValue).toLowerCase());
  //     const matchCity = CityList?.find(item => item.id == cityValue || item.cityName.toLowerCase() === String(cityValue).toLowerCase());
  //     setFormData((prev) => ({
  //       ...prev,
  //       ['country']: match ? match.id : "0",
  //       ['state']: matchState ? matchState.id : "0",
  //       ['city']: matchCity ? matchCity.id : "0",
  //     }));
  //     handleState(match ? match.id : "0")
  //     handleCity(matchState ? matchState.id : "0", match ? match.id : "0")
  //     console.log(match?.id);
  //     console.log(matchState?.id);
  //     console.log(matchCity?.id);
  //   }

  // }, [selectedLocation]);

  // 1️⃣ When selectedLocation changes → set country
  useEffect(() => {
    if (!selectedLocation || !CountryList?.length) return;

    const countryValue = selectedLocation.country || "";
    const postalCode = selectedLocation.postalCode || "";
    const displayAddress = selectedLocation.displayAddress || "";
    const latitude = selectedLocation.latitude || "";
    const longitude = selectedLocation.longitude || "";
    const placeId = selectedLocation.placeId || "";
    const matchCountry = CountryList.find(
      item =>
        item.id == countryValue ||
        item.name.toLowerCase() === String(countryValue).toLowerCase()
    );

    if (matchCountry) {
      setFormData(prev => ({ ...prev, country: matchCountry.id }));
      setFormData(prev => ({ ...prev, pincode: postalCode }));
      setFormData(prev => ({ ...prev, address: displayAddress }));
      setFormData(prev => ({ ...prev, latitude: latitude }));
      setFormData(prev => ({ ...prev, longitude: longitude }));
      setFormData(prev => ({ ...prev, placeId: placeId }));
      handleState(matchCountry.id); // fetch states based on country
    }
  }, [selectedLocation, CountryList]);

  // 2️⃣ When StateList loads → set state
  useEffect(() => {
    if (!selectedLocation || !StateList?.length) return;

    const stateValue = selectedLocation.state || "";
    const matchState = StateList.find(
      item =>
        item.id == stateValue ||
        item.name.toLowerCase() === String(stateValue).toLowerCase()
    );

    if (matchState) {
      setFormData(prev => ({ ...prev, state: matchState.id }));
      // ✅ Use formData.country (not prev.country)
      handleCity(matchState.id, formData.country);
    }
  }, [StateList]);

  // 3️⃣ When CityList loads → set city
  useEffect(() => {
    if (!selectedLocation || !CityList?.length) return;

    const cityValue = selectedLocation.city || "";
    const matchCity = CityList.find(
      item =>
        item.id == cityValue ||
        item.cityName.toLowerCase() === String(cityValue).toLowerCase()
    );

    if (matchCity) {
      setFormData(prev => ({ ...prev, city: matchCity.id }));
    }
  }, [CityList]);

  const handleChange = (e) => {
    const { name, type, value, files } = e.target;

    if (type === "file" && files.length > 0) {
      const file = files[0];
      const reader = new FileReader();

      reader.onloadend = () => {
        setFormData((prev) => ({
          ...prev,
          [name]: file, // actual file
          [`${name}_preview`]: reader.result, // preview URL
        }));
      };

      reader.readAsDataURL(file);
    } else {
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  const handleChangeDate = (e, field = '') => {
    let name = '';
    let value = '';
    if (e.target) {
      name = e.target.name;
      value = e.target.value;
    } else {
      name = field//field.name;
      value = e;
    }
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };


  // (a) weekly open/close schedule
  const handleDayToggle = (dayKey) => {
    setFormData((prev) => ({
      ...prev,
      store_timings: {
        ...prev.store_timings,
        [dayKey]: {
          ...prev.store_timings[dayKey],
          is_open: !prev.store_timings[dayKey]?.is_open,
        },
      },
    }));
  };

  const handleDayTimeChange = (dayKey, field, value) => {
    setFormData((prev) => ({
      ...prev,
      store_timings: {
        ...prev.store_timings,
        [dayKey]: {
          ...prev.store_timings[dayKey],
          [field]: value,
        },
      },
    }));
  };

  // (b) product types (tags)
  const handleAddProductType = () => {
    const value = productTypeInput.trim();
    if (!value) return;
    setFormData((prev) => {
      if (prev.product_types.some((t) => t.toLowerCase() === value.toLowerCase())) {
        return prev;
      }
      return { ...prev, product_types: [...prev.product_types, value] };
    });
    setProductTypeInput('');
  };

  const handleRemoveProductType = (value) => {
    setFormData((prev) => ({
      ...prev,
      product_types: prev.product_types.filter((t) => t !== value),
    }));
  };

  // (d) up to 5 gallery images
  const handleGalleryChange = (e) => {
    const files = Array.from(e.target.files || []);
    if (!files.length) return;
    setFormData((prev) => {
      const room = 5 - existingGalleryImages.length - prev.store_images.length;
      if (room <= 0) {
        toastr.warning('You can upload a maximum of 5 store images.');
        return prev;
      }
      return { ...prev, store_images: [...prev.store_images, ...files.slice(0, room)] };
    });
    e.target.value = '';
  };

  const handleRemoveNewGalleryImage = (index) => {
    setFormData((prev) => ({
      ...prev,
      store_images: prev.store_images.filter((_, i) => i !== index),
    }));
  };

  // Edit mode: clicking the cross (X) on an already-saved store image removes
  // it immediately, so we confirm first and toast the result either way.
  const handleRemoveExistingGalleryImage = async (imageId) => {
    const confirmed = window.confirm('Are you sure you want to remove this image?');
    if (!confirmed) return;

    const previous = existingGalleryImages;
    setExistingGalleryImages((prev) => prev.filter((img) => img.id !== imageId));
    try {
      const response = await removeStoreImage(imageId);
      if (!response?.status?.success) {
        throw new Error(response?.message || 'Failed to remove image');
      }
      toastr.success('Image removed successfully');
    } catch (err) {
      setExistingGalleryImages(previous);
      toastr.error(err?.message || 'Failed to remove image');
    }
  };

  const [pathnameChanged, setPathnameChanged] = useState(location.pathname);

  useEffect(() => {
    setPathnameChanged(location.pathname);
  }, [location.pathname]);

  // Fills the form from an existing store row (admin: from the list, store: from /store/fetch)
  const loadEditData = (parsedData) => {
    const latitude = parsedData.latitude;
    const longitude = parsedData.longitude;

    if (latitude !== null && latitude !== undefined &&
      latitude !== "" && longitude !== null &&
      longitude !== undefined && longitude !== ""
    ) {
      setSelectedLocation({
        latitude: Number(latitude),
        longitude: Number(longitude),
        displayAddress: parsedData.address || "",
        country: parsedData.country || "",
        state: parsedData.state || "",
        city: parsedData.city || "",
        postalCode: parsedData.pincode || "",
        placeId: parsedData.placeId || "",
      });
    } else {
      setSelectedLocation(null);
    }
    let timings = parsedData.store_timings;
    if (typeof timings === 'string') {
      try { timings = JSON.parse(timings); } catch { timings = null; }
    }

    let types = parsedData.product_types;
    if (typeof types === 'string') {
      try { types = JSON.parse(types); } catch { types = []; }
    }

    setFormData({
      ...parsedData,
      password: '', // don't load the stored hash into the form (it would be re-hashed on save)
      store_timings: timings || defaultStoreTimings(),
      product_types: Array.isArray(types) ? types : [],
      enquiry_enabled: parsedData.enquiry_enabled ? '1' : '0',
      payment_enabled: parsedData.payment_enabled ? '1' : '0',
      platform_fee: parsedData.platform_fee ?? '',
      platform_fee_payer: parsedData.platform_fee_payer || 'store',
      is_halal: parsedData.is_halal ? '1' : '0',
      food_type: parsedData.food_type || '',
      alcohol_allowed: parsedData.alcohol_allowed ? '1' : '0',
      store_images: [],
    });
    setExistingGalleryImages(Array.isArray(parsedData.images) ? parsedData.images : []);
  };

  // Store editing itself: load its own row (api.js sends the store token on /store-panel pages)
  const loadOwnStore = async () => {
    try {
      const res = await fetchstores(5, 1, null);
      const rows = res?.data?.data || [];
      let ownId = null;
      try { ownId = JSON.parse(localStorage.getItem('store_panel_auth'))?.store?.id; } catch { /* ignore */ }
      const own = rows.find((s) => s.id == ownId) || rows[0];
      if (!own) throw new Error('Store not found');
      loadEditData(own);
      fetchcountrylist(own);
    } catch (err) {
      toastr.error(err?.message || 'Could not load your store');
    }
  };

  // After a store saves itself: refresh images/logo and the panel header
  const handleStoreSaved = (saved = {}) => {
    setExistingGalleryImages(Array.isArray(saved.images) ? saved.images : []);
    setFormData((p) => ({
      ...p,
      store_images: [],
      password: '',
      password_confirmation: '',
      store_logo: saved.store_logo || p.store_logo,
    }));
    if (fileInputRef.current) fileInputRef.current.value = '';
    try {
      const auth = JSON.parse(localStorage.getItem('store_panel_auth') || 'null');
      if (auth) {
        auth.store = { ...(auth.store || {}), store_name: saved.store_name, store_logo: saved.store_logo };
        localStorage.setItem('store_panel_auth', JSON.stringify(auth));
        window.dispatchEvent(new Event('store-auth-updated'));
      }
    } catch { /* ignore */ }
  };

  useEffect(() => {
    if (isStore) {
      loadOwnStore();
      return;
    }

    if (pathnameChanged === '/store/edit') {
      const editData = localStorage.getItem('storeEditData');
      if (editData) loadEditData(JSON.parse(editData));
    } else {
      localStorage.removeItem('storeEditData');
    }

    fetchcountrylist();
    fetchcategorylist();
  }, [pathnameChanged]);

  const fetchcategorylist = async () => {
    const categories = await fetchstorecategories();
    setCategoryList(categories?.result || categories?.data || []);
  }

  const fetchcountrylist = async (storeData) => {
    const country = await fetchcountries();
    setCountryList(country.result);
    let editparseddata = storeData || null;
    if (!editparseddata) {
      const editData = localStorage.getItem('storeEditData');
      editparseddata = editData ? JSON.parse(editData) : null;
    }
    if (editparseddata && country?.result?.length > 0) {
      const states = await fetchstates(editparseddata.country);
      setStateList(states.result);
      if (states) {
        const cities = await fetchcities(editparseddata.state, editparseddata.country);
        setCityList(cities.result);
      }
    }
  }

  const handleState = async (value) => {
    // setselectedCountry(e)
    // const value = e.target.value;
    const states = await fetchstates(value);
    setStateList(states.result);

  };
  const handleCity = async (value) => {
    // const countryId = selectedCountry.id
    // const value = e.target.value;
    const cities = await fetchcities(value, formData.country);
    setCityList(cities.result);
  };


  const handleSubmit = async (e) => {

    e.preventDefault();
    const formDataToSend = new FormData();
    for (let key in formData) {
      if (key === "store_logo") {
        if (!formData[key] || typeof formData[key] === "string") {
          continue;
        }
      }
      // (a)/(b) these are objects/arrays — JSON-encode them, handled separately below
      if (key === "store_timings" || key === "product_types") {
        continue;
      }
      // (d) files are appended individually below, not as a single field
      if (key === "store_images") {
        continue;
      }

      if (isStore && (key === "platform_fee" || key === "platform_fee_payer")) {
        continue;
      }

      if (formData[key] === null || formData[key] === "") {
        continue;
      }
      formDataToSend.append(key, formData[key]);
    }
    if (isStore) formDataToSend.append("isStore", "1");
    // (a) weekly schedule
    formDataToSend.append("store_timings", JSON.stringify(formData.store_timings));
    // (b) product types
    formDataToSend.append("product_types", JSON.stringify(formData.product_types));
    // (d) up to 5 gallery images
    formData.store_images.forEach((file) => {
      formDataToSend.append("store_images[]", file);
    });
    if (!formData.store_name || formData.store_name === "") {
      toastr.error("Please Enter Store Name")
      return false
    }

    if (!formData.type || formData.type === "") {
      toastr.error("Please Enter Store Type")
      return false
    }

    if (!formData.contact_name || formData.contact_name === "") {
      toastr.error("Please Enter Contact Name")
      return false
    }
    if (!selectedLocation || selectedLocation.latitude == null ||
      selectedLocation.longitude == null ) {
      toastr.error("Please choose a valid store location.");
      return;
    }
    if (!formData.country || formData.country === "") {
      toastr.error("Please Enter Country")
      return false
    }

    if (!formData.state || formData.state === "") {
      toastr.error("Please Enter state")
      return false
    }
    if (!formData.city || formData.city === "") {
      toastr.error("Please Enter city")
      return false
    }
    if (!formData.email || formData.email === "") {
      toastr.error("Please Enter Email")
      return false
    }

    if (isStore || pathnameChanged === '/store/edit') { } else {

      if (!formData.password || formData.password === "") {
        toastr.error("Please Enter Password")
        return false
      }

      if (!formData.password_confirmation || formData.password_confirmation === "") {
        toastr.error("Please Enter Password Confirmation")
        return false
      }

      if (formData.password && formData.password !== "" && formData.password_confirmation && formData.password_confirmation !== "" && formData.password_confirmation !== formData.password) {
        toastr.error("Password Mismatch")
        return false
      }
    }

    if (!formData.phone || formData.phone === "") {
      toastr.error("Please Enter Contact Number")
      return false
    }

    if (!formData.pincode || formData.pincode === "") {
      toastr.error("Please Enter Store Pincode")
      return false
    }
    if (!isStore && formData.enquiry_enabled !== '1' && formData.payment_enabled !== '1') {
      toastr.error("Please enable Enquiry, Payment, or both.")
      return false
    }
    if (!isStore && formData.vendortype == "1") {
      if (!formData.noOfPass || formData.noOfPass == '0' || formData.noOfPass == "") {
        toastr.error("Please Enter total number of pass. value should be greater than Zero.")
        return false
      }
      if (!formData.rewardrequired || formData.rewardrequired == '0' || formData.rewardrequired == "") {
        toastr.error("Please Enter GT Coint Required.")
        return false
      }
      if (!formData.event_time || formData.event_time == '0' || formData.event_time == "") {
        toastr.error("Please Select event time.")
        return false
      }
      if (!formData.entry_time || formData.entry_time == '0' || formData.entry_time == "") {
        toastr.error("Please Select entry time.")
        return false
      }
      if (!formData.gatenumber || formData.gatenumber == '0' || formData.gatenumber == "") {
        toastr.error("Please Enter Gate Number.")
        return false
      }

    }
    if (!isStore && formData.swipelimit == "1") {
      if (!formData.swipeinyear || formData.swipeinyear == '0' || formData.swipeinyear == "") {
        toastr.error("Please Enter number Maximum time in year. value should be greater than Zero.")
        return false
      }
      if (!formData.monthlyswipe || formData.monthlyswipe == '0' || formData.monthlyswipe == "") {
        toastr.error("Please Enter number Maximum time in day. value should be greater than Zero.")
        return false
      }
    }

    if (!isStore && formData.payment_enabled === '1' && formData.platform_fee !== '') {
      const fee = parseFloat(formData.platform_fee);
      if (isNaN(fee) || fee < 0 || fee > 100) {
        toastr.error("Platform fee must be a percentage between 0 and 100.")
        return false
      }
    }

    // console.log(formData);
    // return false;

    try {
      const response = await dispatch(saveStore(formDataToSend)).unwrap();

      toastr.options = {
        closeButton: true,
        progressBar: true,
        timeOut: 3000,
        positionClass: 'toast-top-right'
      };
      if (response.status.success && isStore) {
        toastr.success(response.message);
        handleStoreSaved(response.result);
        return;
      }
      if (response.status.success) {
        toastr.success(response.message)
        setFormData({
          store_name: "",
          store_id: "",
          address: "",
          settlement_day: "",
          email: "",
          phone: "",
          noOfPass: "",
          dealtype: 0,
          rewardtype: 0,
          dealvalue: 0,
          ownervalue: 0,
          custvalue: 0,
          ordervalue: 0,
          rewardvalue: 0,
          swipelimit: '0',
          monthlyswipe: '0',
          swipeinyear: '0',
          store_timings: defaultStoreTimings(),
          product_types: [],
          enquiry_enabled: '1',
          payment_enabled: '0',
          platform_fee: '',
          platform_fee_payer: 'store',
          store_images: [],
          is_halal: '0',
          food_type: '',
          alcohol_allowed: '0',
        });
        setExistingGalleryImages([]);
        if (fileInputRef.current) {
          fileInputRef.current.value = '';
        }
        navigate('/store');
      } else {
        toastr.error(response.message)
      }
      localStorage.removeItem('storeEditData');
    }  catch (error) {
    console.error("Store save error:", error);
    // Laravel validation errors
    if (error?.error && typeof error.error === "object") {
        Object.values(error.error).forEach((messages) => {
            if (Array.isArray(messages)) {
                messages.forEach((message) => {
                    toastr.error(message);
                });
            } else if (messages) {
                toastr.error(messages);
            }
        });
        return;
    }

    // Normal API error
    if (error?.message) {
        toastr.error(error.message);
        return;
    }

    toastr.error("Registration failed. Please try again.");
}
  };
  // const [selectedTime, setSelectedTime] = useState("");

  // Generate time options in 5-minute intervals
  const generateTimes = () => {
    const times = [];
    for (let hour = 0; hour < 24; hour++) {
      for (let min = 0; min < 60; min += 5) {
        const h = hour.toString().padStart(2, "0");
        const m = min.toString().padStart(2, "0");
        times.push(`${h}:${m}:00`);
      }
    }
    return times;
  };

  const times = generateTimes();
  return (
    <div className="flex flex-col md:flex-row gap-4 md:gap-4">
      <div className="w-full bg-white shadow-lg rounded-2xl p-4 space-y-4">
        <form onSubmit={handleSubmit}>
          <h2 className="text-2xl font-bold text-center mb-2">{isStore ? 'Manage Profile' : 'Add New Vendor'}</h2>

          {/* Name Fields */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">

            {!isStore && (
            <div>
              <label className="block text-sm font-medium mb-2">Vendor Type <span className="text-red-500">*</span></label>
              <div className=" gap-6">
                {['0', '1'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="vendortype"
                      value={type}
                      checked={formData.vendortype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '0' ? "Store" : "Events"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>
            )}
            
            <div>
              <label className="block text-sm font-medium mb-1">Store/Event Name <span className="text-red-500">*</span></label>
              <div className="relative">
                <input
                  type="text"
                  name="store_name"
                  value={formData.store_name || ""}
                  onChange={handleChange}
                  placeholder="24/7 store/Event Comedy Carnival.."
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Store className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            {!isStore && (<>
            <div>
              <label className="block text-sm font-medium mb-1">Store / Event ID / Code <span className="text-red-500">*</span></label>
              <div className="relative">
                <input
                  readOnly
                  type="text"
                  name="store_id"
                  value={formData.store_id || ""}
                  onChange={handleChange}
                  placeholder="OZS-9876565656"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <IdCard className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

              <div>
              <label className="block text-sm font-medium mb-1">Vendor Category <span className="text-red-500">*</span></label>
              <div className="relative">
                <select
                  name="vendor_category"
                  value={formData.vendor_category || ""}
                  onChange={handleChange}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                >
                  <option value="">Select Category</option>
                  {CategoryList && CategoryList.length > 0 && CategoryList.map((item, key) => (
                    <option key={key} value={item}>{item}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Vendor Type <span className="text-red-500">*</span></label>
              <div className="relative">
                <select name="type" value={formData.type || ""} onChange={handleChange} className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                >
                  <option value="" disabled>Select</option>
                  <option value="Event">Event</option>
                  <option value="Restaurant">Restaurant</option>
                  <option value="Meat_Shop">Meat Shop</option>
                  <option value="Beauty_And_Salon">Beauty And Salon</option>
                  <option value="Laundry_Service">Laundry Service</option>
                  <option value="Medical_Care_And_Hospital">Medical Care And Hospital</option>
                  <option value="Retail">Retail</option>
                  <option value="Transport">Transport</option>
                  <option value="Gym">Gym</option>
                  <option value="Wholesale">Wholesale</option>
                  <option value="Online">Online</option>
                  <option value="Boutiques">Boutiques</option>
                  <option value="Electronics">Electronics</option>
                  <option value="Malls">Malls</option>
                  <option value="Supermarkets">Supermarkets</option>
                  <option value="Hypermarkets">Hypermarkets</option>
                  <option value="Franchises">Franchises</option>
                  <option value="Convenience_Stores">Convenience Stores</option>
                  <option value="Discount_Stores">Discount Stores</option>
                  <option value="E-commerce_Retailers">E-commerce Retailers</option>
                  <option value="General_Store">General Store</option>
                  <option value="Online_Retailing">Online Retailing</option>
                  <option value="Itinerant_Retailers">Itinerant Retailers</option>
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div >
              <label className="block text-sm font-medium mb-2">Food & Beverage Options</label>
              <div className="flex flex-wrap items-center gap-6">
                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={formData.is_halal === '1'}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, is_halal: e.target.checked ? '1' : '0' }))
                    }
                  />
                  <span className="text-sm font-medium">Halal</span>
                </label>

                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={formData.alcohol_allowed === '1'}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, alcohol_allowed: e.target.checked ? '1' : '0' }))
                    }
                  />
                  <span className="text-sm font-medium">Alcohol Allowed</span>
                </label>
              </div>

              <div className="flex flex-wrap gap-6 mt-3">
                {[
                  { value: '', label: 'Not specified' },
                  { value: 'veg', label: 'Veg only' },
                  { value: 'non_veg', label: 'Non-Veg only' },
                  { value: 'both', label: 'Veg & Non-Veg' },
                ].map((opt) => (
                  <label key={opt.value} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="food_type"
                      value={opt.value}
                      checked={formData.food_type === opt.value}
                      onChange={handleChange}
                    />
                    <span className="text-sm font-medium">{opt.label}</span>
                  </label>
                ))}
              </div>
            </div>
            </>)}

            <div>
              <label className="block text-sm font-medium mb-1">Contact Name</label>
              <div className="relative">
                <input
                  type="text"
                  name="contact_name"
                  value={formData.contact_name || ""}
                  onChange={handleChange}
                  placeholder="Doe"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Password</label>
              <div className="relative">
                <input
                  id="password"
                  type="password"
                  name="password"
                  value={formData.password || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  autoComplete="new-password"
                  onChange={handleChange}
                />
                <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Confirm Password</label>
              <div className="relative">
                <input
                  id="password_confirmation"
                  type="password"
                  name="password_confirmation"
                  value={formData.password_confirmation || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  autoComplete="new-password"
                  onChange={handleChange}
                />
                <LockIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Email <span className="text-red-500">*</span></label>
              <div className="relative">
                <input
                  type="email"
                  name="email"
                  readOnly={isStore}
                  value={formData.email || ""}
                  onChange={handleChange}
                  placeholder="Store’s official email"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Phone Number <span className="text-red-500">*</span></label>
              <div className="flex">
                {/* Country Code Select */}
                <div className="relative">
                  <select
                    name="country_code"
                    disabled={isStore}
                    value={formData.country_code || "91"}
                    onChange={handleChange}
                    className="h-full rounded-l-xl border border-r-0 pl-3 pr-2 py-2 focus:ring-2 focus:ring-[#f4a406]"
                  >
                    {/* <option value="+1">US +1</option> */}
                    <option value="91">IN +91</option>
                    <option value="971">AE +971</option>
                    {/* <option value="+44">🇬🇧 +44</option>
                    <option value="+61">🇦🇺 +61</option> */}
                  </select>
                </div>

                {/* Phone Number Input */}
                <div className="relative flex-1">
                  <input
                    type="tel"
                    name="phone"
                    readOnly={isStore}
                    value={formData.phone || ""}
                    onChange={handleChange}
                    placeholder="234 567 890"
                    className="w-full pl-10 pr-4 py-2 border rounded-r-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                  <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                </div>
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Alternate Phone Number</label>
              <div className="relative">
                <input
                  type="tel"
                  name="alt_mobile"
                  value={formData.alt_mobile || ""}
                  onChange={handleChange}
                  placeholder="+1 234 567 890"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Choose Your Location <span className="text-red-500">*</span></label>

              {selectedLocation ? (
                <div className="p-3 bg-gray-50 border rounded-xl flex items-start justify-between gap-3">
                  <div>
                    <p className="text-sm font-medium text-gray-800">
                      {selectedLocation.displayAddress}
                    </p>
                    {selectedLocation.area && (
                      <p className="text-xs text-gray-500 mt-1">Area: {selectedLocation.area}</p>
                    )}
                  </div>
                  <button
                    type="button"
                    onClick={() => setIsLocationModalOpen(true)}
                    className="text-sm font-medium text-[#f4a406] hover:text-[#d89005] whitespace-nowrap"
                  >
                    Change
                  </button>
                </div>
              ) : (
                <button
                  type="button"
                  onClick={() => setIsLocationModalOpen(true)}
                  className="w-full flex items-center justify-center gap-2 border border-dashed rounded-xl py-2 text-sm font-medium text-gray-600 hover:border-[#f4a406] hover:text-[#f4a406] transition-colors"
                >
                  <MapPinIcon size={16} />
                  Detect or pick location on map
                </button>
              )}

              <LocationPickerModal
                isOpen={isLocationModalOpen}
                onClose={() => setIsLocationModalOpen(false)}
                onLocationSelect={handleLocationSelect}
                apiKey="AIzaSyD1683tMzeZXGFhxXEr96VwjffvcrmVWTc"
              />
              {/* <LocationSelector /> */}
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">Country <span className="text-red-500">*</span></label>
              <div className="relative">
                <label htmlFor="country" value="Country" />
                <select id="country" name="country"
                  // onChange={e => { handleState(e); }}
                  onChange={e => {
                    const value = e.target.value;
                    setFormData(prev => ({ ...prev, country: value }));
                    handleState(value);
                  }}
                  value={formData.country || ""}
                  // value={
                  //   // If formData.country is a name, find its id
                  //   (() => {
                  //     const countryValue = formData?.country || '';
                  //     const match =
                  //       CountryList?.find(
                  //         item =>
                  //           item.id == countryValue ||
                  //           item.name.toLowerCase() === String(countryValue).toLowerCase()
                  //       );
                  //     return match ? match.id : "0";
                  //   })()
                  // }
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {CountryList && CountryList.length > 0 && CountryList.map((item, key) => (
                    <option key={key} value={item.id}>{item.name}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">State <span className="text-red-500">*</span></label>
              <div className="relative">
                <label htmlFor="state" value="state" />
                <select id="state" name="state"
                  onChange={e => {
                    const value = e.target.value;
                    setFormData(prev => ({ ...prev, state: value }));
                    handleCity(value);
                  }}
                  value={formData.state || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {StateList && StateList.length > 0 && StateList.map((item, key) => (
                    <option key={key} value={item.id}>{item.name}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">City <span className="text-red-500">*</span></label>
              <div className="relative">
                <label htmlFor="city" value="city" />
                <select id="city" name="city"
                  onChange={e => { const value = e.target.value; setFormData(prev => ({ ...prev, city: value })); }}
                  value={formData.city || ""}
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]">
                  <option value="0">Select</option>
                  {CityList && CityList.length > 0 && CityList.map((item, key) => (
                    <option key={key} value={item.id}>{item.cityName}</option>
                  ))}
                </select>
                <ListCheck className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>


            {!isStore && (
            <div>
              <label className="block text-sm font-medium mb-1">Website URL</label>
              <div className="relative">
                <input
                  type="text"
                  name="website_url"
                  value={formData?.website_url || ""}
                  onChange={handleChange}
                  placeholder="www.xyzabc.com"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <ExternalLink className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            )}

            <div>
              <label className="block text-sm font-medium mb-1">Pincode <span className="text-red-500">*</span></label>
              <div className="relative">
                <input
                  type="text"
                  name="pincode"
                  value={formData?.pincode || ""}
                  onChange={handleChange}
                  placeholder="Pincode"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <MapPinIcon className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium mb-1">Description</label>
              <div className="relative">
                <textarea
                  type="text"
                  name="description"
                  value={formData.description || ""}
                  onChange={handleChange}
                  placeholder="About Store"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <AlignLeft className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">address</label>
              <div className="relative">
                <input
                  type="text"
                  name="address"
                  value={formData.address || ""}
                  onChange={handleChange}
                  placeholder="Store Address"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <AlignLeft className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>

            {!isStore && (<>
            <div>
              <label className="block text-sm font-medium mb-1">Settlement Days</label>
              <div className="relative">
                <input
                  type="number"
                  name="settlement_day"
                  value={formData.settlement_day || ""}
                  onChange={handleChange}
                  placeholder="Settlement Days"
                  className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <AlignLeft className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">OTP Allowed</label>
              <div className=" gap-6">
                {['1', '0'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="OTPAllowed"
                      value={type}
                      checked={formData.OTPAllowed == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '1' ? "Yes" : "No"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2">Face Recognition Allowed </label>
              <div className=" gap-6">
                {['1', '0'].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="FaceRecognition"
                      value={type}
                      checked={formData.FaceRecognition == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === '1' ? "Yes" : "No"}
                    </span>&nbsp;
                  </label>
                ))}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium mb-2">
                Swipe Rules
                <p className="italic text-gray-600 font-thin">
                  No limit means user can swipe unlimited time at this store. For Custom Swipe limit should be in number of times. Like 5,10,20,50...
                  {/* <InfoIcon className="absolute left-20 top-1/2 -translate-y-1/2 text-red-400" size={18} /> */}
                </p>
              </label>
              <div className=" gap-6">
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="swipelimit"
                      value={type}
                      checked={formData.swipelimit == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "No Limit" : "Custom Limit"}
                    </span>&nbsp;
                  </label>
                ))}

                {formData.swipelimit == 1 && (
                  <>
                    <div className=" gap-6">
                      <label className="block text-sm font-medium mb-2">Maximum time in Year(s)  </label>
                      <input
                        type="number"
                        name="swipeinyear"
                        value={formData.swipeinyear || ""}
                        onChange={handleChange}
                        placeholder="Enter number"
                        className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                    </div>
                    <div className=" gap-6">
                      <label className="block text-sm font-medium mb-2">Maximum time in Day(s)</label>
                      <input
                        type="number"
                        name="monthlyswipe"
                        value={formData.monthlyswipe || ""}
                        onChange={handleChange}
                        placeholder="Enter number"
                        className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                      />
                    </div>
                  </>
                )}

              </div>
            </div>
            {formData.vendortype == 1 && (
              <>
                <div className="grid grid-cols-3 gap-2">
                  <div>
                    <label className="block text-sm font-medium mb-1">Event Date</label>
                    <div className="relative">
                      <DateInput
                        valueFormat="DD-MM-YYYY"
                        minDate={new Date()}
                        placeholder="Event date"
                        value={formData.event_date}
                        onChange={(date) => {
                          handleChangeDate(date, 'event_date');
                        }}
                        leftSection={<CalendarDays size={18} className="text-gray-400" />}
                        className="w-full rounded-xl"
                      />
                      {/* <Flatpickr
                      value={new Date(formData.event_date)}
                      // onChange={([date]) => handleChange(date, 'event_date')}
                      onChange={([date]) => {
                        handleChangeDate(date, 'event_date')
                      }}
                      options={{
                        minDate: 'today',
                        enableTime: false,
                        time_24hr: false,
                        defaultDate: null,
                        altFormat: 'Y-m-d (UTCZ)',
                        dateFormat: "d/m/Y", // Format: DD/MM/YYYY
                      }}
                      placeholder="Select a date"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <CalendarDays className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} /> */}
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Event Time</label>
                    <div className="relative">
                      <div className="relative w-full">
                        <select
                          name="event_time"
                          className="block w-full appearance-none rounded-lg border border-gray-300 bg-white py-2 px-3 text-sm text-gray-700 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                          value={formData.event_time}
                          onChange={handleChange}
                        >
                          <option value="">-- Select Time --</option>
                          {times.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>

                        {/* Down arrow icon */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="absolute right-3 top-3 h-4 w-4 text-gray-400 pointer-events-none"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                  <div>
                    <label className="block text-sm font-medium mb-1">Entry Time</label>
                    <div className="relative">
                      <div className="relative w-full">
                        <select
                          name="entry_time"
                          className="block w-full appearance-none rounded-lg border border-gray-300 bg-white py-2 px-3 text-sm text-gray-700 shadow-sm focus:border-blue-500 focus:ring-2 focus:ring-blue-200"
                          value={formData.entry_time}
                          onChange={handleChange}
                        >
                          <option value="">-- Select Time --</option>
                          {times.map((time, index) => (
                            <option key={index} value={time}>
                              {time}
                            </option>
                          ))}
                        </select>

                        {/* Down arrow icon */}
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          className="absolute right-3 top-3 h-4 w-4 text-gray-400 pointer-events-none"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
                        </svg>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Total No. Of Pass</label>
                  <div className="relative">
                    <input
                      type="number"
                      name="noOfPass"
                      value={formData.noOfPass || ""}
                      onChange={handleChange}
                      placeholder="Enter number"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <Binary className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                  </div>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">GT Coint Required </label>
                  <div className="relative">
                    <input
                      type="number"
                      name="rewardrequired"
                      value={formData.rewardrequired || ""}
                      onChange={handleChange}
                      placeholder="Enter number"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <CircleStop className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />

                  </div>
                  <p className="italic text-gray-600 font-thin">
                    The user event pass can only be downloaded if the required GT Coin is available / validate. If not requred leave it blank.
                  </p>
                </div>
                <div>
                  <label className="block text-sm font-medium mb-1">Gate Number </label>
                  <div className="relative">
                    <input
                      type="text"
                      name="gatenumber"
                      value={formData.gatenumber || ""}
                      onChange={handleChange}
                      placeholder="Gate Number"
                      className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                    <Binary className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />

                  </div>

                </div>
              </>

            )}


            {/* <div>
              <label className="block text-sm font-medium mb-2">Deals In</label>
              <div className=" gap-6">
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="dealtype"
                      value={type}
                      checked={formData.dealtype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "Percentage" : "Fixed"}
                    </span>&nbsp;
                  </label>
                ))}
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Total value</label>
                  <input
                    type="number"
                    name="dealvalue"
                    value={formData.dealvalue || ""}
                    onChange={handleChange}
                    placeholder="Total value"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Value for custmer</label>
                  <input
                    type="number"
                    name="custvalue"
                    value={formData.custvalue || ""}
                    onChange={handleChange}
                    placeholder="value for custmer"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Value for owner</label>
                  <input
                    type="number"
                    name="ownervalue"
                    value={formData.ownervalue || ""}
                    onChange={handleChange}
                    placeholder="value owner"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
              </div>
            </div> */}
            {/* <div>
              <label className="block text-sm font-medium mb-2">Reward formula</label>
              <div className=" gap-6">

                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Order value</label>
                  <input
                    type="number"
                    name="ordervalue"
                    value={formData.ordervalue || ""}
                    onChange={handleChange}
                    placeholder="Order value"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>
                {["0", "1"].map((type) => (
                  <label key={type} className="inline-flex items-center gap-2">
                    <input
                      type="radio"
                      name="rewardtype"
                      value={type}
                      checked={formData.rewardtype == type}
                      onChange={handleChange}
                    // className="accent-[#f4a406]"
                    />
                    <span className="text-sm font-medium">
                      {type === "0" ? "Percentage" : "Fixed"}
                    </span>&nbsp;
                  </label>
                ))}
                <div className=" gap-6">
                  <label className="block text-sm font-medium mb-2">Get Reward value</label>
                  <input
                    type="number"
                    name="rewardvalue"
                    value={formData.rewardvalue || ""}
                    onChange={handleChange}
                    placeholder="Enter value % OR Fixed"
                    className="w-full pl-5 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                  />
                </div>

              </div>
            </div> */}
            </>)}

            {/* (a) Weekly open/close schedule — unchecking a day marks it closed */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-2">Store Hours</label>
              <div className="border rounded-xl divide-y">
                {DAYS.map(({ key, label }) => {
                  const day = formData.store_timings[key] || {};
                  return (
                    <div key={key} className="flex flex-wrap items-center gap-3 p-3">
                      <label className="inline-flex items-center gap-2 w-32">
                        <input
                          type="checkbox"
                          checked={!!day.is_open}
                          onChange={() => handleDayToggle(key)}
                        />
                        <span className="text-sm font-medium">{label}</span>
                      </label>
                      {day.is_open ? (
                        <div className="flex items-center gap-2">
                          <Clock className="text-gray-400" size={16} />
                          <input
                            type="time"
                            value={day.open_time || '09:00'}
                            onChange={(e) => handleDayTimeChange(key, 'open_time', e.target.value)}
                            className="border rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-[#f4a406]"
                          />
                          <span className="text-sm text-gray-500">to</span>
                          <input
                            type="time"
                            value={day.close_time || '18:00'}
                            onChange={(e) => handleDayTimeChange(key, 'close_time', e.target.value)}
                            className="border rounded-lg px-2 py-1 text-sm focus:ring-2 focus:ring-[#f4a406]"
                          />
                        </div>
                      ) : (
                        <span className="text-sm text-gray-400 italic">Closed</span>
                      )}
                    </div>
                  );
                })}
              </div>
            </div>

            {/* (b) Product types dealt in — e.g. Puma -> Shoes, Sandals */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">Product Types</label>
              <div className="flex gap-2">
                <input
                  type="text"
                  value={productTypeInput}
                  onChange={(e) => setProductTypeInput(e.target.value)}
                  onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                      e.preventDefault();
                      handleAddProductType();
                    }
                  }}
                  placeholder="e.g. Shoes, Sandals, Apparel"
                  className="flex-1 pl-4 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                />
                <button
                  type="button"
                  onClick={handleAddProductType}
                  className="px-4 py-2 rounded-xl bg-[#f4a406] text-white hover:bg-[#d89005] inline-flex items-center gap-1"
                >
                  <Plus size={16} /> Add
                </button>
              </div>
              {formData.product_types.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.product_types.map((type) => (
                    <span
                      key={type}
                      className="inline-flex items-center gap-1 bg-gray-100 text-gray-700 text-sm px-3 py-1 rounded-full"
                    >
                      {type}
                      <button type="button" onClick={() => handleRemoveProductType(type)}>
                        <X size={14} className="text-gray-500 hover:text-red-500" />
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* (c) Enquiry / Payment / Both */}
            {!isStore && (
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-2">Payment & Enquiry Options</label>
              <div className="flex flex-wrap gap-6">
                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={formData.enquiry_enabled === '1'}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, enquiry_enabled: e.target.checked ? '1' : '0' }))
                    }
                  />
                  <span className="text-sm font-medium">Enquiry Enabled</span>
                </label>
                <label className="inline-flex items-center gap-2">
                  <input
                    type="checkbox"
                    checked={formData.payment_enabled === '1'}
                    onChange={(e) =>
                      setFormData((prev) => ({ ...prev, payment_enabled: e.target.checked ? '1' : '0' }))
                    }
                  />
                  <span className="text-sm font-medium">Payment Enabled</span>
                </label>
              </div>
              <p className="italic text-gray-600 font-thin">
                Check both to allow customers to enquire and pay directly. At least one must stay checked.
              </p>
            </div>
            )}

            {/* Platform fee — admin only (hidden on store self-edit) */}
            {!isStore && formData.payment_enabled === '1' && (
              <div className="md:col-span-2">
                <label className="block text-sm font-medium mb-2">Platform Fee</label>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Fee (%)</label>
                    <input
                      type="number"
                      name="platform_fee"
                      min="0"
                      max="100"
                      step="0.01"
                      value={formData.platform_fee}
                      onChange={handleChange}
                      placeholder="e.g. 2.5"
                      className="w-full px-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406]"
                    />
                  </div>
                  <div>
                    <label className="block text-xs text-gray-600 mb-1">Fee paid by</label>
                    <div className="flex gap-6 py-2">
                      {[{ value: 'store', label: 'Store' }, { value: 'customer', label: 'Customer' }].map((opt) => (
                        <label key={opt.value} className="inline-flex items-center gap-2">
                          <input
                            type="radio"
                            name="platform_fee_payer"
                            checked={formData.platform_fee_payer === opt.value}
                            onChange={() => setFormData((prev) => ({ ...prev, platform_fee_payer: opt.value }))}
                          />
                          <span className="text-sm font-medium">{opt.label}</span>
                        </label>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* (d) Multi store image upload — up to 5 images */}
            <div className="md:col-span-2">
              <label className="block text-sm font-medium mb-1">
                Store Images ({existingGalleryImages.length + formData.store_images.length}/5) <small>(Max. 4 MB per image)</small>
              </label>
              <div className="flex flex-wrap gap-3 mb-3">
                {existingGalleryImages.map((img) => (
                  <div key={img.id} className="relative w-24 h-24 border rounded-xl overflow-hidden">
                    <img src={img.image_path} alt="Store" className="w-full h-full object-cover" />
                    <button
                      type="button"
                      onClick={() => handleRemoveExistingGalleryImage(img.id)}
                      className="absolute top-1 right-1 bg-white/90 rounded-full p-0.5"
                    >
                      <X size={14} className="text-red-500" />
                    </button>
                  </div>
                ))}
                {formData.store_images.map((file, index) => (
                  <div key={index} className="relative w-24 h-24 border rounded-xl overflow-hidden">
                    <img src={URL.createObjectURL(file)} alt="New upload" className="w-full h-full object-cover" />
                    <button
                      type="button"
                      onClick={() => handleRemoveNewGalleryImage(index)}
                      className="absolute top-1 right-1 bg-white/90 rounded-full p-0.5"
                    >
                      <X size={14} className="text-red-500" />
                    </button>
                  </div>
                ))}
              </div>
              {existingGalleryImages.length + formData.store_images.length < 5 && (
                <div className="relative">
                  <input
                    type="file"
                    accept="image/*"
                    multiple
                    onChange={handleGalleryChange}
                    className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#f4a406] file:text-white hover:file:bg-yellow-600"
                  />
                  <Image className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                </div>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Upload Store Logo <small>(Max. 2 MB)</small></label>
              <div className="flex items-center gap-4">
                <div className="relative flex-1">
                  <input
                    type="file"
                    ref={fileInputRef}
                    name="store_logo"
                    accept="image/*"
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-2 border rounded-xl focus:ring-2 focus:ring-[#f4a406] file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-[#f4a406] file:text-white hover:file:bg-yellow-600"
                  />
                  <Image className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                </div>

                {formData.store_logo && (
                  <div className="w-32 h-24 border rounded-xl overflow-hidden">
                    <img
                      src={
                        typeof formData.store_logo === 'string'
                          ? `${formData.store_logo}`
                          : formData.store_logo_preview
                      }
                      alt="Uploaded Preview"
                      className="w-full h-full object-cover"
                    />
                  </div>
                )}
              </div>
            </div>


          </div>

          <br></br>

          {/* Submit */}
          <button
            type="submit"
            className="w-full bg-[#f4a406] text-white py-2 rounded-xl hover:bg-[#d89005] transition-colors"
          >
            Save
          </button>
        </form>
      </div >

    </div >
  );
}